/* ============
 * Mutation types for the unit-types module
 * ============
 *
 * The mutation types that are available
 * on the unit-types module.
 */

export const LOAD = 'LOAD';
export const LOAD_PANORAMA = 'LOAD_PANORAMA';

export default {
  LOAD,
  LOAD_PANORAMA,
};
